export default "__VITE_ASSET__DQl1HzFG__"